const addHoursMinutes = (hour1, hour2) => {
  // Convert hours to minutes
  const [hour1Hours, hour1Minutes] = hour1.split(':').map(Number);
  const [hour2Hours, hour2Minutes] = hour2.split(':').map(Number);
  const totalMinutes =
    hour1Hours * 60 + hour1Minutes + (hour2Hours * 60 + hour2Minutes);
  // Convert minutes back to hours and minutes
  let hours = Math.floor(totalMinutes / 60);
  let minutes = totalMinutes % 60;
  // Format to HH:MM
  hours = `${hours < 10 ? `0${hours}` : hours}`;
  minutes = `${minutes < 10 ? `0${minutes}` : minutes}`;
  return `${hours}:${minutes}`;
};

const checkHourAndPushToList = (item, currentHour, list) => {
  if (item.hour === currentHour) {
    list.push({ id: item.id, hour: currentHour });
  }
};

export const generateListFromInterval = (
  initialHour,
  interval,
  providedList
) => {
  const list = [];
  let currentHour = addHoursMinutes(initialHour, interval); // Calculate the first hour after the initial hour
  const processItem = (item) => checkHourAndPushToList(item, currentHour, list);
  for (;;) {
    providedList.forEach(processItem);
    currentHour = addHoursMinutes(currentHour, interval);
    if (currentHour > providedList[providedList.length - 1].hour) {
      break;
    }
  }
  return list;
};
